import React from "react";
import { steps } from "../mock";

export default function Process() {
  return (
    <section id="process" className="bg-white py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="reveal text-center max-w-2xl mx-auto">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#1B45C4]">Så funkar det</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900">Fyra steg till ett rent & skyddat tak</h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={s.title} className="reveal relative rounded-2xl bg-[#f0f7ff] light-card p-7 ring-1 ring-[#dbeafe] transition-all hover:bg-white hover:shadow-xl hover:shadow-[#1B45C4]/10">
                <span className="absolute top-6 right-6 font-display text-5xl font-extrabold text-[#1B45C4]/10">{i + 1}</span>
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl hpr-gradient text-white shadow-lg shadow-[#1B45C4]/25">
                  <Icon className="w-7 h-7" />
                </div>
                <h3 className="mt-5 text-lg font-bold text-slate-900">{s.title}</h3>
                <p className="mt-2 text-slate-600 text-[15px]">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
